import React from 'react'
import { SwiperProps, SwiperSlide } from 'swiper/react'

import Slider from '@components/Content/Slider/Slider'

import useNewsPosts from '@hooks/useNewsPosts'

import * as styles from './FeaturedPostsSlider.module.scss'
import NewsPostCard from './NewsPostCard'

const FeaturedPostsSlider = () => {
	const featuredPosts = useNewsPosts({ featuredOnly: true })

	const postsSlides = featuredPosts.map((post) => {
		return (
			<SwiperSlide key={post.id} className={styles.slide}>
				<NewsPostCard post={post} />
			</SwiperSlide>
		)
	})

	const sliderOptions: SwiperProps = {
		autoHeight: true,
	}

	return <Slider slides={postsSlides} className={styles.slider} options={sliderOptions} />
}

export default FeaturedPostsSlider
